webpackJsonp([230539012308250],{

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    text-align: left;\n    ', ' {\n        border-radius: ', ';\n    }\n'], ['\n    text-align: left;\n    ', ' {\n        border-radius: ', ';\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    background: none;\n    height: 1.5rem;\n    line-height: 1rem;\n    position: relative;\n    text-align: center;\n    &:before {\n        background: ', ';\n        content: \'\';\n        height: 1px;\n        left: 0;\n        position: absolute;\n        top: 50%;\n        width: 100%;\n    }\n    &:after {\n        background: ', ';\n        color: ', ';\n        content: \'', '\';\n        display: inline-block;\n        font-size: ', 'px;\n        line-height: 1.5rem;\n        padding: 0 ', 'px 0 ', 'px;\n        position: relative;\n        text-transform: uppercase;\n    }\n'], ['\n    background: none;\n    height: 1.5rem;\n    line-height: 1rem;\n    position: relative;\n    text-align: center;\n    &:before {\n        background: ', ';\n        content: \'\';\n        height: 1px;\n        left: 0;\n        position: absolute;\n        top: 50%;\n        width: 100%;\n    }\n    &:after {\n        background: ', ';\n        color: ', ';\n        content: \'', '\';\n        display: inline-block;\n        font-size: ', 'px;\n        line-height: 1.5rem;\n        padding: 0 ', 'px 0 ', 'px;\n        position: relative;\n        text-transform: uppercase;\n    }\n']);
	
	var _reactFontawesome = __webpack_require__(25);
	
	var _designSystem = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoadingBar = __webpack_require__(143);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	var _api = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Form = _designSystem.Box.withComponent('form').extend.attrs({ bg: 'white', p: 4 })(_templateObject, function (_ref) {
	    var theme = _ref.theme;
	    return theme.mediaQueries.md;
	}, function (_ref2) {
	    var theme = _ref2.theme;
	    return theme.radii[3];
	});
	
	var TextDivider = _designSystem.Divider.extend(_templateObject2, (0, _designSystem.cx)('muted'), (0, _designSystem.cx)('white'), (0, _designSystem.cx)('muted'), function (props) {
	    return props.text;
	}, function (_ref3) {
	    var theme = _ref3.theme;
	    return theme.fontSizes[1];
	}, function (_ref4) {
	    var theme = _ref4.theme;
	    return theme.space[2];
	}, function (_ref5) {
	    var theme = _ref5.theme;
	    return theme.space[2];
	});
	
	var authPath = _api.url + '/v1/users/auth';
	
	var LoginForm = function LoginForm(_ref6) {
	    var status = _ref6.status,
	        props = _objectWithoutProperties(_ref6, ['status']);
	
	    var innerContent = void 0;
	    switch (status) {
	        case 'loading':
	            innerContent = _react2.default.createElement(_LoadingBar2.default, null);
	            break;
	        case 'ready':
	        case 'failed':
	        default:
	            innerContent = _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                    _designSystem.Heading.h2,
	                    { mb: 4 },
	                    'Login'
	                ),
	                _react2.default.createElement(
	                    _designSystem.Box,
	                    null,
	                    _react2.default.createElement(_designSystem.Field, { label: 'Email', name: 'email', type: 'email', placeholder: 'orpheus@hackclub.com' }),
	                    _react2.default.createElement(
	                        _designSystem.Button,
	                        { w: 1 },
	                        'Get login code'
	                    )
	                ),
	                _react2.default.createElement(TextDivider, { my: 3, text: 'or' }),
	                _react2.default.createElement(
	                    _designSystem.Box,
	                    null,
	                    _react2.default.createElement(
	                        _designSystem.Button,
	                        { href: authPath + '/slack', bg: 'black', w: 1, inverted: true },
	                        _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: ['fab', 'slack-hash'], color: (0, _designSystem.cx)('primary') }),
	                        ' Login with Slack'
	                    ),
	                    _react2.default.createElement(
	                        _designSystem.Button,
	                        { href: authPath + '/github', bg: '#333', mt: 3, w: 1 },
	                        _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: ['fab', 'github'] }),
	                        ' Login with GitHub'
	                    )
	                )
	            );
	            break;
	        case 'success':
	            innerContent = _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(_LoadingBar2.default, null),
	                _react2.default.createElement(
	                    _designSystem.Text,
	                    { align: 'center' },
	                    'Authenticated! Logging in now\u2026'
	                )
	            );
	    }
	
	    return _react2.default.createElement(
	        Form,
	        props,
	        innerContent
	    );
	};
	
	exports.default = LoginForm;
	module.exports = exports['default'];

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _designSystem = __webpack_require__(4);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _qs = __webpack_require__(271);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(43);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(46);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _LoginForm = __webpack_require__(574);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	var _api = __webpack_require__(74);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _storage = __webpack_require__(590);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Login = function (_Component) {
	    _inherits(Login, _Component);
	
	    function Login() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Login);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { status: 'loading' }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Login.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        var params = _qs2.default.parse(this.props.location.search.substring(1));
	
	        // Initial state: at /login without a stored token
	        if (!params.auth_token && !_storage2.default.get('authToken')) {
	            this.setState({ status: 'ready' });
	            return;
	        }
	
	        switch (params.status) {
	            case 'success':
	                _storage2.default.set('authToken', params.auth_token);
	                this.setState({ status: 'success' });
	                break;
	            case 'failed':
	                this.setState({ status: 'failed' });
	                return;
	            default:
	                this.setState({ status: 'loading' });
	                break;
	        }
	        // Auth token found, verify it
	        _api2.default.get('v1/users/current', { headers: { Authorization: 'Bearer ' + _storage2.default.get('authToken') } }).then(function (_ref) {
	            var data = _ref.data;
	
	            if (!_storage2.default.get('userId')) {
	                _storage2.default.set('userId', data.id);
	                setTimeout(function () {
	                    return (0, _gatsbyLink.navigateTo)('/');
	                }, 2000); // Imitate loading effect
	                return;
	            }
	            (0, _gatsbyLink.navigateTo)('/');
	        }).catch(function (e) {
	            _this2.setState({ status: e.response.status === 401 ? 'ready' : 'error' });
	        });
	    };
	
	    Login.prototype.render = function render() {
	        return _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Login' }),
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement('style', { children: '\n                    body {\n                        background: linear-gradient(\n                            48deg,\n                            ' + (0, _designSystem.cx)('orange.5') + ',\n                            ' + (0, _designSystem.cx)('red.4') + ',\n                            ' + (0, _designSystem.cx)('pink.3') + '\n                        );\n                    }\n                ' }),
	            _react2.default.createElement(
	                _designSystem.Container,
	                { maxWidth: 32, pt: 6, pb: [4, null, 5] },
	                _react2.default.createElement(_LoginForm2.default, { status: this.state.status })
	            )
	        );
	    };
	
	    return Login;
	}(_react.Component);
	
	exports.default = Login;
	module.exports = exports['default'];

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var stubbedStorage = {};
	
	var methods = ['getItem', 'setItem', 'removeItem'];
	methods.forEach(function (method) {
	    return stubbedStorage[method] = function () {
	        return null;
	    };
	});
	
	var localStorage = void 0;
	try {
	    localStorage = window.localStorage;
	} catch (e) {
	    if (e instanceof ReferenceError) {
	        localStorage = stubbedStorage;
	    }
	}
	
	var storage = {
	    get: function get(key) {
	        return JSON.parse(localStorage.getItem(key));
	    },
	    set: function set(key, value) {
	        return localStorage.setItem(key, JSON.stringify(value));
	    },
	    remove: function remove(key) {
	        return localStorage.removeItem(key);
	    }
	};
	
	exports.default = storage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-login-js-8ed6d7062333b99afd13.js